<template>
  <div class="card border border-2 border-custom-300 border-hover">
    <div class="pt-6 text-center">
      <div class="card-title m-0">
        <i
          :class="icon"
          class="px-3"
        />
      </div>
      <span
        :class="statusBadgeColor"
        class="badge"
      >{{ status }}</span>
    </div>

    <div class="card-body py-3">
      <div class="fs-3 fw-bolder text-dark">
        {{ title }}
      </div>

      <p class="text-gray-400 fw-bold fs-5 mt-1 mb-7">
        {{ description }}
      </p>

      <div
        :class="badges > 3 ? 'flex-wrap' : ''"
        class="d-flex text-center justify-content-center"
      >
        <div
          v-for="badgeNumber in badges"
          :key="badgeNumber.length"
          :style="badges > 3 ? 'width: 30%;' : ''"
          class="border border-custom-300 border-dashed rounded py-3 px-4 mx-2 mb-3"
        >
          <div class="fw-bold text-gray-400">
            {{ infoBadgeTitle[badgeNumber - 1] }}
          </div>
          <div class="fs-7 text-gray-800 fw-bolder">
            {{ infoBadgeDescription[badgeNumber - 1] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Card',
  props: {
    statusBadgeColor: { Type: String, default: 'badge-light' },
    statusDataColor: String,
    status: { Type: String, default: 'Status' },
    icon: { Type: String, default: 'bi bi-truck' },
    title: String,
    description: String,
    badges: { Type: Number, default: 0 },
    infoBadgeTitle: Array,
    infoBadgeDescription: Array
  }
})
</script>
<style lang="scss" scoped>
i {
  font-size: 32px;
  color: #f67f01;
  line-height: 1.5;
}

.card {
  margin: 5px auto;
}

.badge {
  text-transform: uppercase;
  background: #f67f01;
  color: #fff;
}

.border {
  width: 100%;
}

.border-custom-300 {
  border-color: #f67f01 !important;
}

@media (max-width: 768px) {
  .card {
    margin: 5px 0;
    border-width: 1px !important;
  }

  .pt-6 {
    padding-top: 0.75rem !important;
  }

  .card-body {
    padding: 0.75rem !important;
  }

  .fs-3 {
    font-size: 1rem !important;
  }

  .fs-5 {
    font-size: 0.8rem !important;
    margin-top: 0.25rem !important;
    margin-bottom: 0.5rem !important;
  }

  .fs-7 {
    font-size: 0.75rem !important;
  }

  i {
    font-size: 20px;
  }

  .badge {
    font-size: 0.7rem;
    padding: 0.25rem 0.5rem;
  }

  .d-flex .border {
    padding: 0.5rem !important;
    margin: 0.25rem !important;

    .fw-bold.text-gray-400 {
      font-size: 1rem;
      margin-bottom: 0.25rem;
    }
  }

  // Dla większej liczby badge'ów (powyżej 3)
  .d-flex.flex-wrap .border {
    width: calc(50% - 0.5rem) !important;
    margin: 0.25rem !important;
  }
}

@media (max-width: 480px) {
  .card {
    margin: 5px 0;
  }

  .pt-6 {
    padding-top: 0.5rem !important;
  }

  .card-body {
    padding: 0.5rem !important;
  }

  .fs-3 {
    font-size: 0.9rem !important;
  }

  .fs-5 {
    font-size: 0.75rem !important;
  }

  .fs-7 {
    font-size: 1rem !important;
  }

  i {
    font-size: 18px;
  }

  .badge {
    font-size: 0.65rem;
    padding: 0.2rem 0.4rem;
  }

  .d-flex .border {
    padding: 0.4rem !important;
    margin: 0.2rem !important;
  }

  // Na bardzo małych ekranach pokaż badge'y w kolumnie
  .d-flex {
    flex-direction: column !important;

    .border {
      width: 100% !important;
      margin: 0.2rem 0 !important;
    }
  }
}
</style>